"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CyclicDependencyError = exports.ServiceHolder = void 0;
var error_messages_1 = require("../constants/error-messages");
/**
 * 模块Holder，用于在DI框架中保存模块的构造函数和模块实例
 */
var ServiceHolder = /** @class */ (function () {
    // ServiceHolder的descriptor可能为null
    function ServiceHolder(instance, descriptor) {
        this.instance = instance;
        this.descriptor = descriptor;
    }
    return ServiceHolder;
}());
exports.ServiceHolder = ServiceHolder;
/**
 *  循环依赖异常告警
 */
var CyclicDependencyError = /** @class */ (function (_super) {
    __extends(CyclicDependencyError, _super);
    function CyclicDependencyError(graph) {
        var _this = _super.call(this, error_messages_1.SERVICES_CYCLIC_DEPENDENCY) || this;
        _this.message = graph.toString();
        return _this;
    }
    return CyclicDependencyError;
}(Error));
exports.CyclicDependencyError = CyclicDependencyError;
//# sourceMappingURL=typing.js.map